module.exports = __webpack_public_path__ + "static/media/sf-trial-3.04916ece.mp3";